import {CanActivateFn} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {inject} from '@angular/core';
import {NavigationService} from '../services/navigation.service';

export const notLoggedInGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const navigationService: NavigationService = inject(NavigationService);

  if (!authService.getStoredToken()) {
    return true;
  } else {
    navigationService.goToHome();
    return false;
  }
};
